import React from 'react'

interface FlightDetailsDepartureProps {
    isLast?: boolean
    isTripStart?: boolean
}

const FlightDetailsDeparture = ({ isLast = false, isTripStart = false }: FlightDetailsDepartureProps) => {
    return (
        <svg width="11" height="76" viewBox="0 0 11 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            {isLast && <path d="M5.5 34L5.5 1" stroke="#B3B3B3" stroke-linecap="round" stroke-dasharray="2 3" />}
            {isTripStart ? (
                <circle cx="5.5" cy="38.5" r="5.5" fill="#B3B3B3" />
            ) : (
                <circle cx="5.5" cy="38.5" r="4.5" fill="white" stroke="#B3B3B3" stroke-width="2" />
            )}
            <g clip-path="url(#clip0_2086_100759)">
                <rect x="6" y="43" width="33" height="1" transform="rotate(90 6 43)" fill="#B3B3B3" />
            </g>
            <defs>
                <clipPath id="clip0_2086_100759">
                    <rect x="6" y="43" width="33" height="1" rx="0.5" transform="rotate(90 6 43)" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default FlightDetailsDeparture
